






















import Vue from 'vue'
export default Vue.extend({
  name: 'LoadingDialogComp',
  props: ['isLoading', 'message'],
})
